import { handleActions } from 'redux-actions'

import * as rawActions from '../actions'
import { FormFolder } from '../types'

export default handleActions<FormFolder | null, any>(
  {
    [rawActions.setCurrentFolder.toString()](state, action) {
      return action.payload
    },
    [rawActions.clearCurrentFolder.toString()](state, action) {
      return null
    },
  },
  null
)
